interface Props {
  children: React.ReactNode;
  colorSwap?: boolean;
  header: number | string;
}

export default function GlassMonsterInfoCard({ children, colorSwap, header }: Props) {
  if (colorSwap) {
    return (
      <div className='divide-monsterPurple/70 bg-siteBackground/70 nice-pop border-siteBackground/20 divide-y overflow-hidden rounded-lg border text-white shadow-sm backdrop-blur-sm'>
        <div className='px-4 py-5 text-2xl font-bold sm:px-6'>{header}</div>
        <div className='px-4 py-5 sm:p-6'>{children}</div>
      </div>
    );
  }

  return (
    <div className='divide-monsterPurple/70 bg-siteBackgroundLighter/70 text-siteBackground border-siteBackgroundLighter/20 nice-pop divide-y overflow-hidden rounded-lg border shadow-sm backdrop-blur-sm'>
      <div className='px-4 py-5 text-2xl font-bold sm:px-6'>{header}</div>
      <div className='px-4 py-5 sm:p-6'>{children}</div>
    </div>
  );
}
